import classNames from "classnames";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import RadioDot from "../../Homepage/components/RadioDot";

const PaymentMethod = ({
  onSelect,
  image,
  images,
  isSelected,
  name,
  fullWidth,
  translate
}) => {
  return (
    <button
      type={"button"}
      className={classNames(
        "flex gap-3 h-11 px-3.5 bg-white align-center payment-method rounded",
        {
          "payment-method_selected": isSelected,
          "w-full": fullWidth
        }
      )}
      onClick={onSelect}
    >
      <RadioDot isSelected={isSelected} />
      <span className={"font-medium text-xs text-black whitespace-nowrap"}>
        {translate(`paymentMethod_${name}`)}
      </span>
      {images ? (
        images
      ) : (
        <img
          src={image.src}
          alt={image.src}
          height={28}
          className={"ml-auto"}
        />
      )}
    </button>
  );
};

export default compose(withTranslations)(PaymentMethod);
